import { createLitComponent } from "../lib/create-lit-component.js";
import { GivebutterSignupForm } from "@givebutter/widgets-core";
//#region src/components/GivebutterSignupForm.tsx
const GivebutterSignupForm$1 = createLitComponent({
	elementClass: GivebutterSignupForm,
	tagName: "givebutter-signup-form"
});
//#endregion
export { GivebutterSignupForm$1 as GivebutterSignupForm };
